import { FieldModel } from '@cibo/core'
import { IrrigationCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface IrrigationCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const IrrigationCell = ({ value, task, year, selectedField }: IrrigationCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="irrigation"
    >
      <IrrigationCellDisplay value={value} />
    </TraitCellContainer>
  )
}
